import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface MapfreTabsData {
  value: string;
  label: string;
  url: string;
  active?: boolean;
}

@Component({
  selector: 'app-mapfre-tabs',
  templateUrl: './mapfre-tabs.component.html',
  styleUrls: ['./mapfre-tabs.component.scss'],
})
export class MapfreTabsComponent implements OnInit {

  @Input() tabs: MapfreTabsData[];
  @Output() tabChanged: EventEmitter<MapfreTabsData>;

  tabWidth: string;

  constructor(
    private cdr: ChangeDetectorRef,
  ) {
    this.tabs = [];
    this.tabChanged = new EventEmitter<MapfreTabsData>();
  }

  ngOnInit() {
    if (!this.tabs.find(tab => tab.active)) {
      this.tabs[0].active = true;
    }
    this.setTabsWith();
  }

  onChange(data: MapfreTabsData, index: number, div: HTMLSpanElement) {
    div.style.left = this.getActiveBarPosition(index);
    this.tabs.forEach((tab) => {
      tab.active = false;
    });
    this.tabs[index].active = true;
    this.cdr.detectChanges();
    this.tabChanged.emit(data);
  }

  private setTabsWith() {
    this.tabWidth = (100 / this.tabs.length) + '%';
  }

  private getActiveBarPosition(index: number): string {
    const length = this.tabs.length;
    return (((index) * 100) / length) + '%';
  }

}
